import {
    ref,
    uploadBytes,
    getDownloadURL,
    deleteObject
} from "firebase/storage";
import { storage } from "../config";

export const uploadDeckImage = async (file, userId, deckId = null) => {
    try {
        if (!file.type.startsWith('image/')) {
            throw new Error('Plik musi być obrazem');
        }

        const maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
            throw new Error('Plik jest za duży. Maksymalny rozmiar to 5MB');
        }

        const timestamp = Date.now();
        const fileExtension = file.name.split('.').pop();
        const fileName = deckId
            ? `deck_${deckId}_${timestamp}.${fileExtension}`
            : `deck_${userId}_${timestamp}.${fileExtension}`;

        const storagePath = `tracker/decks/${fileName}`;
        const storageRef = ref(storage, storagePath);
        const snapshot = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);

        return {
            url: downloadURL,
            path: storagePath,
            fileName: fileName
        };
    } catch (error) {
        console.error("Błąd podczas przesyłania zdjęcia talii:", error);
        throw error;
    }
};

export const deleteDeckImage = async (imagePath) => {
    try {
        if (!imagePath) return;

        const storageRef = ref(storage, imagePath);
        await deleteObject(storageRef);
        return true;
    } catch (error) {
        console.error("Błąd podczas usuwania zdjęcia talii:", error);
        return false;
    }
};

export const getDeckImageURL = async (imagePath) => {
    try {
        if (!imagePath) return null;

        const storageRef = ref(storage, imagePath);
        const downloadURL = await getDownloadURL(storageRef);
        return downloadURL;
    } catch (error) {
        console.error("Błąd podczas pobierania URL zdjęcia talii:", error);
        return null;
    }
};
